import React from 'react'
import { Controller } from 'react-hook-form'
import {
  Box,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { DatePicker, TimePicker } from '@material-ui/pickers'
import clsx from 'clsx'

import constants from 'constants/index'

import useStyles from './styles'

const { DISPATCH_SCHEDULED, DISPATCH_OPTIONS } = constants.phishing

const DispatchSelector = ({ dispatchType, onChange, control, disabled }) => {
  const classes = useStyles()

  const radioClass = (value) =>
    clsx(classes.radioOption, {
      [classes.radioOptionSelected]: dispatchType === value,
    })

  return (
    <RadioGroup
      className={classes.radioGroup}
      value={dispatchType}
      onChange={disabled ? undefined : onChange}
    >
      {DISPATCH_OPTIONS.map((option) => (
        <React.Fragment key={option.value}>
          <FormControlLabel
            value={option.value}
            label={option.label}
            className={radioClass(option.value)}
            control={<Radio size="small" color="primary" disabled={disabled} />}
          />

          {/* Campos de data e hora visíveis apenas quando "Agendar disparo" está selecionado */}
          {option.value === DISPATCH_SCHEDULED &&
            dispatchType === DISPATCH_SCHEDULED && (
              <Box className={classes.scheduledFieldsWrapper}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Controller
                      as={
                        <DatePicker
                          fullWidth
                          format="DD/MM/yyyy"
                          label="Data de disparo"
                          inputVariant="outlined"
                          onChange={(newValue) => ({ value: newValue })}
                          disablePast
                          disabled={disabled}
                        />
                      }
                      control={control}
                      name="scheduledDate"
                      mode="onChange"
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <Controller
                      as={
                        <TimePicker
                          fullWidth
                          format="HH:mm"
                          label="Horário de disparo"
                          inputVariant="outlined"
                          ampm={false}
                          onChange={(newValue) => ({ value: newValue })}
                          disabled={disabled}
                        />
                      }
                      control={control}
                      name="scheduledTime"
                      mode="onChange"
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
        </React.Fragment>
      ))}
    </RadioGroup>
  )
}

export default DispatchSelector
